import ConfirmDialog from 'antd/es/modal/ConfirmDialog';
export default ConfirmDialog;
